<div fxLayout="column" fxLayoutAlign=" center" class="pd30 fh">

    <div class="w500px pdb50">

        <p>Considerar ID de la transaccion como el nombre del documento unico</p>
        <h6 class="h6Title centertext">Agregar venta manual</h6>
        <div class="fw pdb10 border-b">
            <label>Id de usuario</label>
            <div fxLayout="row" fxLayoutGap="1rem">
                <input type="text" [(ngModel)]="usuario" [ngbTypeahead]="search" [inputFormatter]="formatter" [resultFormatter]="formatter" placement="bottom-left"
                placeholder="Email de usuario" class="fw" />
                <button class="darkButton" (click)="buscar()">Buscar</button>
            </div>
        </div>


        <div *ngIf="usuarioIdInput">

            <div class="fw mgt10">
                <label>ID del usuario</label>
                <input [value]="usuario.uid"class="fw backGray2" readonly>
            </div>

            <div class="fw mgt10">
                <label>Nombre de usuario</label>
                <input [value]="usuario.nombreCompleto" class="fw backGray2" readonly>
            </div>
            <div class="fw mgt10">
                <label>Tipo de usuario</label>
                <select [(ngModel)]="venta.usuarioTipo" [ngModelOptions]="{standalone: true}" class="fw">
                    <option value="estudiante">Estudiante</option>
                    <option value="instructor">Instructor</option>
                    <option value="empresa">Empresa</option>
                    <option value="admin">Admin</option>
                </select>
            </div>

            <div class="fw mgt10">
                <label>Curso</label>
                <div fxLayout="row" fxLayoutGap="1rem">
                    <input type="text" [(ngModel)]="curso" [ngbTypeahead]="searchCursos" [inputFormatter]="formatterCursos" [resultFormatter]="formatterCursos" placement="bottom-left"
                    placeholder="Titulo del curso" class="fw" />
                </div>
            </div>

            <div class="fw mgt10">
                <label>Metodo de cobro</label>
                <select [(ngModel)]="venta.transaccionViaCobro" [ngModelOptions]="{standalone: true}" class="fw">
                    <option value="transferencia Nac MXN">Transferencia Nacional MXN</option>
                    <option value="transferencia Int USD">Transferencia Internacional USD</option>
                    <option value="transferencia Nac USD">Transferencia Nacional USD</option>
                    <option value="zelle">Zelle</option>
                    <option value="BTC">Bitcoin</option>
                    <option value="stripe">Stripe</option>
                    <option value="obsequio">Obsequio</option>
                    <option value="paypal">Paypal</option>
                </select>
            </div>

            <!-- <div class="fw mgt10">
                <label>Fecha de cobro</label>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <input matInput [matDatepicker]="picker" [(ngModel)]="venta.transaccionFecha" class="fw">
                <mat-datepicker #picker></mat-datepicker>
            </div> -->

            <div class="fw mgt10">
                <label>% de descuento (0-100)</label>
                <input type="number" [(ngModel)]="venta.cursoPorcentajeDescuento" [ngModelOptions]="{standalone: true}"
                    class="fw">
            </div>
            <div class="fw mgt10">
                <label>Moneda Transaccion</label>
                <select [(ngModel)]="venta.transaccionMoneda" [ngModelOptions]="{standalone: true}" class="fw">
                    <option value="usd">US Dolar</option>
                    <option value="mxn">Pesos Mexicanos</option>
                    <option value="eur">Euro</option>
                    <option value="btc">Bitcoin</option>
                </select>
            </div>
            <div class="fw mgt10">
                <label>Comentario</label>
                <textarea type="text" [(ngModel)]="venta.transaccionComentario" [ngModelOptions]="{standalone: true}"
                    class="fw"></textarea>
            </div>
            <div class="fw mgt10">
                <label>Impuesto de transaccion en USD </label>
                <input type="number" [(ngModel)]="venta.transaccionTax" [ngModelOptions]="{standalone: true}"
                    class="fw">
            </div>
            <div class="fw mgt10">
                <label>Comision cobro en USD</label>
                <input type="number" [(ngModel)]="venta.transaccionComisionCobro" [ngModelOptions]="{standalone: true}"
                    class="fw">
            </div>
            <div class="fw mgt10">
                <label>Estatus Cobro</label>
                <select [(ngModel)]="venta.transaccionEstatusCobro" [ngModelOptions]="{standalone: true}" class="fw">
                    <option value="paid">Cobrado</option>
                    <option value="unpaid">Pendiente</option>
                    <option value="canceled">Cancelado</option>
                    <option value="refunded">Reembolsado</option>
                </select>
            </div>
            <div class="mgt20 mgb10">
                <button (click)="confirmarRegistroVenta()" class="darkButton fw">Registrar pago</button>
            </div>
            <div *ngIf="pagoRegistrado == true" class="w500px pdb50">
                <div *ngFor="let item of venta | keyvalue" class="fw mgt10">
                    <label>{{item.key}}</label>
                    <input [value]="item.value" class="backGray2 ft08 border-b" class="fw" readonly>
                </div>
                <button class="darkButton" (click)="setVentas()">Confirmar Venta</button>
            </div>
            
        </div>
    </div>
</div>